import { UserInfo } from "../pages/login"

export type Option = {
    Text:string,
    Value:string
}

export type ErrorModel = {
    ErrorResume:string,
    ErrorMessage:string
}

export interface OperateResult{
    /**
     * 警告信息
     */
    WarnMessages:Array<ErrorModel>,
    /**
     * 错误信息
     */
    ErrorMessages:Array<ErrorModel>
}

export type OperateResultPlayod = OperateResult & {
    /**
     * 通知是否需要确认
     */
    NoticeNeedConfirm:boolean
}

export type ScreenInfo = {
    screenSize:ScreenSize,
    width:number,
    height:number
}

/**
 * 屏幕尺寸
 * @param xs 超小 width < 768
 * @param sm 小 width < 992
 * @param md 中等 width < 1200
 * @param lg 大 width < 1980
 * @param xl 超大 width > 1980
 */
export enum ScreenSize {
    /**
     * 超小 width < 768
     */
    xs,
    /**
     * 小 width < 992
     */
    sm,
    /**
     * 中等 width < 1200
     */
    md,
    /**
     * 大 width < 1980
     */
    lg,
    /**
     * 超大 width > 1980
     */
    xl 
}

/**
 * 更新模式
 * @param Value 0 默认固定值
 * @param Formula 1 后端公式
 * @param FrontFormula 2 前端公式
 */
export enum UpdateMode {
    Value = 0,
    Formula = 1,
    FrontFormula = 2
}

/**
 * 修改字段
 */
export type ChangeField = {
    FieldName:string,
    UpdateMode:UpdateMode
    Value:any
}

export type Context = {
    Content:any,
    UserInfo:UserInfo,
    Properties:any
}

export type DepartInfo = {
    Id:number,
    Parentid:number,
    Order:number,
    Name:string,
    Children:Array<DepartInfo>
}

export type FilterResult = {
    Flag : boolean,
    Filter : object 
}

export type PassParams = {
    Key :string,
    Value : any
}

export const TypeEnum = {
    String: '[object String]',
    Number: '[object Number]',
    Boolean: '[object Boolean]',
    Null: '[object Null]',
    Undefined: '[object Undefined]',
    Object: '[object Object]',
    Array: '[object Array]',
    Date: '[object Date]',
    RegExp: '[object RegExp]',
    Error: '[object Error]',
    Function: '[object Function]',
    Map: '[object Map]',
    Set: '[object Set]',
    WeakMap: '[object WeakMap]',
    WeakSet: '[object WeakSet]',
    Symbol: '[object Symbol]',
    Promise: '[object Promise]',
    Generator: '[object Generator]',
    GeneratorFunction: '[object GeneratorFunction]',
    AsyncFunction: '[object AsyncFunction]'
}